var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCustomerFromToken, getRefreshToken } from '../utils';
import { HttpMethod, HttpResponseMockType, Service } from '../enums';
import { createHttpAction } from './utils';
import qs from 'query-string';
export const getUserUpdateStatus = () => {
    const token = getCustomerFromToken();
    const request = {
        service: Service.KEYCLOAK,
        url: '/update-contact/v1/users/:userId/updates/status',
        method: HttpMethod.GET,
        settings: {
            pathParams: { userId: token === null || token === void 0 ? void 0 : token.userId },
        },
    };
    const mock = {
        data: {
            updates_permitted: true,
            updated_last_secs: 24000,
            wait_period_secs: 86400,
        },
        type: HttpResponseMockType.RESOLVE,
    };
    return createHttpAction(request, mock);
};
export const keycloakLogout = ({ clientId } = { clientId: 'login' }) => __awaiter(void 0, void 0, void 0, function* () {
    const refreshToken = getRefreshToken();
    const request = {
        service: Service.KEYCLOAK,
        method: HttpMethod.POST,
        url: '/protocol/openid-connect/logout',
        settings: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        },
        data: qs.stringify({ refresh_token: refreshToken, client_id: clientId }),
    };
    const mock = {
        status: 204,
    };
    return createHttpAction(request, mock);
});
//# sourceMappingURL=keycloak.js.map